import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../Components/const'
import VdpNewVideo from '../Components/VdpNew/VdpNewVideo'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import { VehicleContext } from '../Components/Context/VehicleContext'
import JoinMailing from '../Components/Home/JoinMailing'
import SeoMeta from '../Components/Common/SeoMeta';
const optionssl = {
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true
};
const ModelSpecific = () => {
    const { getVehicleData, numberFormatter, filteredVehicleData } = useContext(VehicleContext);
    const [activeSection, setActiveSection] = useState('overview');
    const galleryWrapRef = useRef(null);
    const [isGalleryNearTop, setIsGalleryNearTop] = useState(false);
    useEffect(() => {
        getVehicleData();
    }, []);
    const [isScrolling, setIsScrolling] = useState(false);

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) {
            const yOffset = -130;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            setIsScrolling(true);
            window.scrollTo({ top: y, behavior: 'smooth' });
            setActiveSection(id);
            setTimeout(() => {
                setIsScrolling(false);
            }, 600);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (isScrolling) return;

            const sections = ['overview', 'gallery', 'performance', 'inventory'];
            let currentSection = activeSection;

            for (let id of sections) {
                const el = document.getElementById(id);
                if (el) {
                    const rect = el.getBoundingClientRect();
                    if (rect.top <= 150 && rect.bottom > 150) {
                        currentSection = id;
                        break;
                    }
                }
            }

            if (currentSection !== activeSection) {
                setActiveSection(currentSection);
            }

            if (galleryWrapRef.current) {
                const rect = galleryWrapRef.current.getBoundingClientRect();
                if (rect.top <= 80) {
                    setIsGalleryNearTop(true);
                    document.body.classList.add('add-sticky-sec');
                } else {
                    setIsGalleryNearTop(false);
                    document.body.classList.remove('add-sticky-sec');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeSection, isScrolling]);


    return (
        <>
            <SeoMeta
                title="McLaren GTS| New & Used McLarens For Sale | McLaren Orlando"
                description="The McLaren GTS is ultra-light engineering. Blistering electrified power. Sublime agility and engagement. McLaren to the core. Discover more today!"
                keywords=""
                ogTitle="McLaren GTS| New & Used McLarens For Sale | McLaren Orlando"
                ogDescription="The McLaren GTS is ultra-light engineering. Blistering electrified power. Sublime agility and engagement. McLaren to the core. Discover more today!"
            />
            <section className='vdp-new-banner-wrap gts-banner-wrap'>
                <img className='w-100' src={getImages('gts-top-bg.jpg')} alt='gts' />
                <div className='vdpn-bottom py-3'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between vdpn-b-flex'>
                            <div className='d-flex align-items-center wow reveal fadeInLeft'>
                                <div className='me-lg-4 me-3'><img src={getImages('mclaren-svgrepo-com.svg')} /></div>
                                <h1 className='lg-title fw-300 text-uppercase font-3-2em'>GTS</h1>
                            </div>
                            <div className='d-flex align-items-center vdpn-b-right wow reveal fadeInRight'>
                                <div>
                                    <a href='#' className='theme-btn text-uppercase fw-500 d-inline-block w-240'>Inquire</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section ref={galleryWrapRef}>
                <section className={`gts-tabs-wrap ${isGalleryNearTop ? 'active' : ''}`}>
                    <div className='nav-tabs-block'>
                        <div className='container'>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeSection === 'overview' ? 'active' : ''}`}
                                        onClick={() => scrollToSection('overview')}>
                                        Overview
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeSection === 'gallery' ? 'active' : ''}`}
                                        onClick={() => scrollToSection('gallery')}>
                                        Gallery
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeSection === 'performance' ? 'active' : ''}`}
                                        onClick={() => scrollToSection('performance')}>
                                        Performance
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeSection === 'inventory' ? 'active' : ''}`}
                                        onClick={() => scrollToSection('inventory')}>
                                        Inventory
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
                {/* Overview */}
                <section id="overview" className='gts-overview-wrap'>
                    <div className='d-lg-flex'>
                        <div className='w-50 order-lg-2 gts-overview-right'>
                            <img className='w-100' src={getImages('vdp-thumb1.jpg')} />
                        </div>
                        <div className='w-50 gts-overview-left'>
                            <div className='mxw-620 ms-auto'>
                                <h2 className='main-title fw-300 text-start text-uppercase mb-4'>Overview</h2>
                                <div className='common-text'>
                                    <p>The GTS is designed to defy your expectations. It's an all-out McLaren supercar, through and through, that refuses to be constrained.</p>
                                    <p>Retaining the core McLaren elements of beautiful yet functional design, class-leading power-to-weight ratio – enabled by lightweight carbon fibre construction centred on a unique monocoque chassis – and unmatched driving dynamics.</p>
                                    <p>It delivers exhilarating power, handling and responsiveness with an extra dimension of effortless usability. Bringing the thrill of the McLaren driving experience to every journey.</p>
                                    <p>So reset your expectations. And live life without constraints.</p>
                                    <div className='mt-5'>
                                        <a href='#' className='sub-sm-btn d-inline-block w-240 text-uppercase'>Learn More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Gallery */}
                <section id="gallery" className='vdp-new-gallery-wrap'>
                    <div className='container'>
                        <h2 className='main-title fw-300 text-start text-uppercase mb-4'>Gallery</h2>
                        <div className='row g-lg-5 g-3'>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb1.jpg')} />
                                </div>
                            </div>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb2.jpg')} />
                                </div>
                            </div>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb3.jpg')} />
                                </div>
                            </div>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb4.jpg')} />
                                </div>
                            </div>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb5.jpg')} />
                                </div>
                            </div>
                            <div className='col-md-6 wow reveal fadeInUp'>
                                <div className='vdpn-gallery-box'>
                                    <img src={getImages('vdp-thumb6.jpg')} />
                                    <div className='vdpn-more-count lg-title font-2em'>+20</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='vdpn-video-wrap pt-4'>
                    <div className='container wow reveal fadeInUp'>
                        <VdpNewVideo />
                    </div>
                </section>
                {/* Performance */}
                <section id="performance" className='vdpn-about-info-wrap gst-info-wrap'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6 ps-lg-5 order-lg-2 mb-lg-0 mb-4'>
                                <ul className='gts-vdpn-list d-flex flex-wrap'>
                                    <li className='w-50 wow reveal fadeInUp'>
                                        <h3 className='xs-title text-orange text-uppercase mb-1'>Top Speed</h3>
                                        <h2 className='lg-title font-2em text-uppercase'>204 mph</h2>
                                    </li>
                                    <li className='w-50 wow reveal fadeInUp'>
                                        <h3 className='xs-title text-orange text-uppercase mb-1'>Horsepower</h3>
                                        <h2 className='lg-title font-2em text-uppercase'>204 mph</h2>
                                    </li>
                                    <li className='w-50 wow reveal fadeInUp'>
                                        <h3 className='xs-title text-orange text-uppercase mb-1'>Torque</h3>
                                        <h2 className='lg-title font-2em text-uppercase'>443 lb-ft</h2>
                                    </li>
                                    <li className='w-50 wow reveal fadeInUp'>
                                        <h3 className='xs-title text-orange text-uppercase mb-1'>0-62 mph</h3>
                                        <h2 className='lg-title font-2em text-uppercase'>3.2 sec</h2>
                                    </li>
                                </ul>
                                <div className='mt-100 row gx-5'>
                                    <div className='col-md-6 wow reveal fadeInUp'>
                                        <div className='gts-download-box d-flex align-items-center'>
                                            <div className='w-100'>
                                                <h4 className='xs-title text-uppercase mb-3'>GTS Brochure</h4>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='xs-title text-orange text-uppercase pt-1'>Download</div>
                                                    <div>
                                                        <img src={getImages('download-anticon.svg')} alt='download' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 wow reveal fadeInUp mt-4 mt-md-0'>
                                        <div className='gts-download-box d-flex align-items-center'>
                                            <div className='w-100'>
                                                <h4 className='xs-title text-uppercase mb-3'>Features & Options Guide</h4>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='xs-title text-orange text-uppercase pt-1'>Download</div>
                                                    <div>
                                                        <img src={getImages('download-anticon.svg')} alt='download' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 mt-4 mt-lg-0'>
                                <h2 className='lg-title fw-300 text-uppercase wow reveal fadeInUp'>PERFORMANCE</h2>
                                <div className='vdpn-ai-content gts-vdpn-ai-content wow reveal fadeInUp'>
                                    <p>McLaren GTS has the highest power-to-weight ratio in its class. A supercar heart, purity of responses and incredible acceleration defines its character. The car is alive to your inputs and will stir the senses. Now more than ever, thanks to increased power and torque. McLaren DNA runs through every detail.</p>
                                    <p>The sheer power and poise delivered by the GTS's awe-inspiring engine and advanced lightweight construction is yours to savour. Whenever and wherever you choose.</p>
                                </div>
                                <div className='d-sm-flex align-items-center mt-5 wow reveal fadeInUp'>
                                    <div className='me-sm-5 mb-sm-0 mb-4'>
                                        <a href="tel:4079880111" className="sub-sm-btn text-uppercase d-inline-block w-240">407-988-0111</a>
                                    </div>
                                    <div>
                                        <Link href="/contact" className="theme-btn text-uppercase d-inline-block w-240">Inquire</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Inventory */}
                <section id="inventory" className='gts-inventory-wrap'>
                    <div className='container'>
                        <h2 className='lg-title fw-300 text-uppercase wow reveal fadeInUp mb-4'>Explore Our Inventory</h2>
                        <div className='row'>
                            {filteredVehicleData && filteredVehicleData.filter((item) => item.model == "GTS").map((item, index) =>
                                <div className='col-lg-4 my-3 my-lg-0 wow reveal fadeInUp' key={index}>
                                    <div className='ls-box'>
                                        <div className='ls-image'>
                                            <img src={item.images[0]} alt='featured' />
                                        </div>
                                        <div className='ls-content'>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <h2 className="fv-title mb-0">{item.vehicle_name}</h2>
                                                <div>
                                                    <button className='info-icon'>
                                                        <img src={getImages('info-icon.png')} alt='icon' />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mt-1 mb-4">
                                                <div className="fv-price">{item.price > 0 ? numberFormatter(item.price, true) : <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}</div>
                                                <div className="fv-mileage">{numberFormatter(item.mileage)} miles</div>
                                            </div>
                                            <div className='text-center'>
                                                <Link
                                                    to={"/vehicle-details/" + item.vdp_url}
                                                    type='button'
                                                    className='theme-btn text-uppercase'>
                                                    Vehicle Details
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </section>
            <JoinMailing />
        </>
    )
}

export default ModelSpecific